import React from "react";

export default function JobPreview({ job }) {
  return (
    <div className="mt-6 ca-card p-6">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-4 gap-4">
        <div>
          <h2 className="text-xl font-bold text-gray-900">{job.title}</h2>
          <p className="text-gray-600 font-medium">{job.companyName}</p>
        </div>
        <img
          src={job.companyLogo}
          alt={`${job.companyName} logo`}
          className="w-16 h-16 sm:w-24 sm:h-24 object-contain rounded-xl bg-white shadow-sm"
        />
      </div>
      <div className="flex flex-wrap gap-4 text-sm text-gray-700 mb-4">
        <p>
          <strong>Type:</strong> {job.type}
        </p>
        <p>
          <strong>Experience:</strong> {job.experience.join(", ")}
        </p>
        <p>
          <strong>Skills:</strong> {job.primarySkills.join(", ")}
        </p>
        <p>
          <strong>Location:</strong> {job.locations.join(", ")}
        </p>
        <p>
          <strong>Apply:</strong>{" "}
          <a href={job.applyUrl} className="text-blue-600 hover:underline">
            {job.applyUrl}
          </a>
        </p>
      </div>
      <div className="text-gray-800 space-y-2">
        <h3 className="font-semibold">Job Description:</h3>
        {job.description.map((line, idx) => (
          <p key={idx} className="leading-relaxed">{line}</p>
        ))}
      </div>
    </div>
  );
}
